import React from "react";
import { Checkbox } from "@cxagroup/casper";
import classnames from "classnames";
import { FormattedMessage } from "react-intl";
import messages from "components/messagesDescription";
import StandardMoney from "../../common/StandardMoney";

const PlanPerMemberForm = ({
  benefit,
  plan,
  eligibleMembers: { members = [] } = {},
  currency,
  onPerMemberClick,
}) => {
  const memberCount = members.length;
  const intervalOption = plan.intervalOptions
    ? plan.intervalOptions.find(option => option.optionId === plan.planId)
    : null;
  const memberPrice =
    intervalOption && intervalOption.memberPrice ? [].concat(intervalOption.memberPrice) : null;
  return members.map(member => (
    <div key={`${benefit.benefitId}-${member.key}`}>
      {member.type === "Employee" &&
        memberCount > 1 && (
          <div>
            <strong className="member-list--label">
              <FormattedMessage {...messages.employeeNameDescription} />:
            </strong>{" "}
            {member.name}
          </div>
        )}
      {member.key &&
        member.type !== "Employee" &&
        (plan.planId !== "0n" && plan.planId !== "0000") && (
          <div className="member-list">
            <Checkbox
              name={`${benefit.benefitId}-${member.key}-${member.name}`}
              id={`${benefit.benefitId}-${member.key}-${member.name}`}
              value={member.key}
              onChange={event => onPerMemberClick(plan, member)(event)}
              disabled={
                !member.isAvailable ||
                member.blockedByChild ||
                (member.isLimit && member.isLimit === "true") ||
                (member.selectable && member.selectable.toString().toLowerCase() !== "true")
              }
              checked={member.isSelected}
              className="member-list--label__item"
            >
              <strong className={classnames({ "member-list--label": member.isAvailable })}>
                <FormattedMessage {...messages.dependantDescription} /> :
              </strong>{" "}
              {member.name}{" "}
            </Checkbox>
            <div className="member-list--item">
              {"+"}{" "}
              {memberPrice ? (
                <StandardMoney
                  value={memberPrice.find(mp => mp.memberKey === member.key).price.value}
                  currency={currency}
                />
              ) : (
                <StandardMoney value={member.price.value} currency={currency} />
              )}
            </div>
          </div>
        )}
    </div>
  ));
};

export default PlanPerMemberForm;



// WEBPACK FOOTER //
// ./components/employee/shop/PlanPerMemberForm.js